import * as $ from 'jquery';
import { onClick, onLoad, onResizeWindow } from 'Core/Events';
import { Breakpoints } from 'Core/Responsiveness';

export const Footer = (() => {

	const Selector = {
		FOOTER_LIST: '.footer-column-content ul',
		FOOTER_COLUMN: '.footer-column',
		FOOTER_SHOW_MORE_BTN: '.js_footer_btn',
		FOOTER_COLUMN_HEADER: '.footer-column-header',
		FOOTER_COLUMN_CONTENT: '.footer-column-content'
	};

	const max: number = 10;
	let currentExpandedSection: JQuery<HTMLElement> | null = null;
	let resizeTimeout: number | null = null;

	onLoad(() => {
		hiderHandler();
	});
	onClick(Selector.FOOTER_SHOW_MORE_BTN, showHideHandler);
	onClick(Selector.FOOTER_COLUMN_HEADER, mobileToggleHandler);
	onResizeWindow(() => {
		if (resizeTimeout) {
			clearTimeout(resizeTimeout);
		}
		resizeTimeout = window.setTimeout(() => {
			resetFooterState();
			hiderHandler();
		}, 250);
	});

	function hiderHandler() {
		if (window.innerWidth < Breakpoints.MD) {
			return;
		}
		
		$(Selector.FOOTER_LIST).each((index, element) => {
			let $list = $(element);
			let countEl = $list.children().length;
			let $target = $list.closest(Selector.FOOTER_COLUMN_CONTENT);

			if (countEl > max) {
				$list.children().each((i) => {
					if (i >= max) {
						$list.children().eq(i).addClass('d-none');
					}
				});
				makeShowHideBtn($target);
			}
		});
	}

	function resetFooterState() {
		$(Selector.FOOTER_LIST).find('li').removeClass('d-none');
		$(Selector.FOOTER_SHOW_MORE_BTN).remove();
	}

	function makeShowHideBtn($target: JQuery<HTMLElement>) {
		const $button = $('<button>')
			.addClass('btn footer_btn js_footer_btn')
			.text('Pokaż więcej');
		$target.append($button);
	}

	function showHideHandler(this: HTMLElement) {
		let $button = $(this);
		let $currentList = $button.closest(Selector.FOOTER_COLUMN_CONTENT).find('ul');

		if ($button.hasClass('active')) {
			$currentList.children().each((i) => {
				if (i >= max) {
					$currentList.children().eq(i).addClass('d-none');
				}
			});
			$button.removeClass('active').text('Pokaż więcej');
		} else {
			$currentList.find('li').removeClass('d-none');
			$button.addClass('active').text('Pokaż mniej');
		}
	}

	function mobileToggleHandler(this: HTMLElement) {
		let $header = $(this);
		let $content = $header.next(Selector.FOOTER_COLUMN_CONTENT);

		if ($content.length === 0) {
			return;
		}

		let isCurrentlyCollapsed = $content.hasClass('collapsed');

		if (currentExpandedSection && !currentExpandedSection.is($content)) {
			currentExpandedSection.addClass('collapsed');
			currentExpandedSection.prev(Selector.FOOTER_COLUMN_HEADER).removeClass('active');
		}

		if (isCurrentlyCollapsed) {
			$content.removeClass('collapsed');
			$header.addClass('active');
			currentExpandedSection = $content;
		} else {
			$content.addClass('collapsed');
			$header.removeClass('active');
			currentExpandedSection = null;
		}
	}

})();
import * as $ from 'jquery';
import { onClick, onLoad, onResizeWindow } from 'Core/Events';
import { Breakpoints } from 'Core/Responsiveness';

export const Footer = (() => {

	const Selector = {
		FOOTER_LIST: '.footer-column-content ul',
		FOOTER_COLUMN: '.footer-column',
		FOOTER_SHOW_MORE_BTN: '.js_footer_btn',
		FOOTER_COLUMN_HEADER: '.footer-column-header',
		FOOTER_COLUMN_CONTENT: '.footer-column-content'
	};

	const max: number = 10;
	let currentExpandedSection: JQuery<HTMLElement> | null = null;
	let resizeTimeout: number | null = null;

	onLoad(() => {
		hiderHandler();
	});
	onClick(Selector.FOOTER_SHOW_MORE_BTN, showHideHandler);
	onClick(Selector.FOOTER_COLUMN_HEADER, mobileToggleHandler);
	onResizeWindow(() => {
		if (resizeTimeout) {
			clearTimeout(resizeTimeout);
		}
		resizeTimeout = window.setTimeout(() => {
			resetFooterState();
			hiderHandler();
		}, 250);
	});

	function hiderHandler() {
		if (window.innerWidth < Breakpoints.MD) {
			return;
		}
		
		$(Selector.FOOTER_LIST).each((index, element) => {
			let $list = $(element);
			let countEl = $list.children().length;
			let $target = $list.closest(Selector.FOOTER_COLUMN_CONTENT);

			if (countEl > max) {
				$list.children().each((i) => {
					if (i >= max) {
						$list.children().eq(i).addClass('d-none');
					}
				});
				makeShowHideBtn($target);
			}
		});
	}

	function resetFooterState() {
		$(Selector.FOOTER_LIST).find('li').removeClass('d-none');
		$(Selector.FOOTER_SHOW_MORE_BTN).remove();
	}

	function makeShowHideBtn($target: JQuery<HTMLElement>) {
		const $button = $('<button>')
			.addClass('btn footer_btn js_footer_btn')
			.text('Pokaż więcej');
		$target.append($button);
	}

	function showHideHandler(this: HTMLElement) {
		let $button = $(this);
		let $currentList = $button.closest(Selector.FOOTER_COLUMN_CONTENT).find('ul');

		if ($button.hasClass('active')) {
			$currentList.children().each((i) => {
				if (i >= max) {
					$currentList.children().eq(i).addClass('d-none');
				}
			});
			$button.removeClass('active').text('Pokaż więcej');
		} else {
			$currentList.find('li').removeClass('d-none');
			$button.addClass('active').text('Pokaż mniej');
		}
	}

	function mobileToggleHandler(this: HTMLElement) {
		let $header = $(this);
		let $content = $header.next(Selector.FOOTER_COLUMN_CONTENT);

		if ($content.length === 0) {
			return;
		}

		let isCurrentlyCollapsed = $content.hasClass('collapsed');

		if (currentExpandedSection && !currentExpandedSection.is($content)) {
			currentExpandedSection.addClass('collapsed');
			currentExpandedSection.prev(Selector.FOOTER_COLUMN_HEADER).removeClass('active');
		}

		if (isCurrentlyCollapsed) {
			$content.removeClass('collapsed');
			$header.addClass('active');
			currentExpandedSection = $content;
		} else {
			$content.addClass('collapsed');
			$header.removeClass('active');
			currentExpandedSection = null;
		}
	}

})();
